
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('g',{attrs:{"clip-path":"url(#clip0_101_29148)","fill":"#2B4BFF"}},[_c('path',{attrs:{"d":"M24.18 18.625c0 3.063-4.101 5.563-9.148 5.563-5.048 0-9.149-2.5-9.149-5.563v-1.438l9.18 3.125 9.117-3.125V18.625z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.416 8c-.252-1.125.631-2.188 1.767-2.188 1.01 0 1.83.813 1.83 1.813v4.124c.63-.062 1.261-.125 1.956-.125.63 0 1.261.063 1.892.125V7.625c0-1 .82-1.813 1.83-1.813 1.136 0 2.019 1.063 1.83 2.188l-.82 4.5c2.65 1 4.479 2.75 4.479 4.75 0 3.062-4.101 5.562-9.148 5.562-5.048 0-9.149-2.5-9.149-5.563 0-2 1.767-3.75 4.417-4.75L9.416 8zm3.029 8.812c0 .813-.442 1.5-1.01 1.5-.568 0-1.01-.687-1.01-1.5 0-.812.442-1.5 1.01-1.5.568 0 1.01.688 1.01 1.5zm5.994 1.5c.568 0 1.01-.687 1.01-1.5 0-.812-.442-1.5-1.01-1.5-.568 0-1.01.688-1.01 1.5 0 .813.442 1.5 1.01 1.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_101_29148"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    